import yup from '@/libs/yup';

export default yup.object({
    idn: yup.string().idn().required()
});
